import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <UrgencyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <BeforeAfterSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <MidPageCTA data-id="element-11" />
        <ValueStackSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <PurchaseSection data-id="element-14" />

        <section className="py-6 px-4 bg-white" data-id="element-15">
          <div className="max-w-3xl mx-auto text-center" data-id="element-16">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-17">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-18" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-19">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-20">
          <p className="text-sm text-gray-300" data-id="element-21">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-22">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-23" />
    </div>;
}